import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

interface IPluralizationKey {
  singular: string;
  plural: string;
}

@Pipe({
  name: 'translatePlural',
})
export class TranslatePluralPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) { }

  transform(key: string, value: string): string {
    const translationKey = this.translocoService.selectTranslateObject(key);
    let translatedValue: string;

    translationKey.subscribe((val: IPluralizationKey): void => {
      if (value === 'singular') {
        translatedValue = val.singular;
      } else {
        translatedValue = val.plural;
      }
    });

    return translatedValue;
  }
}
